import { useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import cn from 'classnames';

import Loader from '../General/Loader';

import './AllBrandsMergeModal.scss';
import { getSmartImage } from '../../helpers/helpers';

const AllBrandsMergeModal = props => {
  const { brands, isSaving, isConflicting, onSave, onCancel } = props;

  const brandsWithNames = _.uniq(brands.filter(brand => brand.name));
  const brandsWithLogos = _.uniq(brands.filter(brand => brand.logo));

  const [mergedName, setMergedName] = useState(() => {
    if (brandsWithNames.length > 0) {
      return brandsWithNames[0].name;
    } else {
      return '';
    }
  });

  const [mergedLogo, setMergedLogo] = useState(() => brandsWithLogos[0]?.logo);

  return (
    <div className='all-brands-merge-modal'>
      <h1>Merge brands</h1>
      <div className='all-brands-merge-name'>
        <h2>Final Name</h2>
        <input type='text' value={mergedName} onChange={e => setMergedName(e.target.value)} />
        {isConflicting && <p className='all-brands-merge-conflict'>There is another brand with this name</p>}
        {brandsWithNames.length > 1 &&
          brandsWithNames.map(brand => (
            <label key={brand.id}>
              <input
                type='radio'
                name='brand-name'
                value={brand.name}
                checked={brand.name === mergedName}
                onChange={e => setMergedName(e.target.value)}
              />
              {brand.name}
            </label>
          ))}
      </div>
      <div className='all-brands-merge-logo'>
        <h2>Logo</h2>
        {brandsWithLogos.map(brand => {
          const cdnLogo = getSmartImage(brand.logo);
          return (
            <label key={brand.id}>
              <input
                type='radio'
                name='brand-logo'
                value={brand.logo}
                checked={brand.logo === mergedLogo}
                onChange={e => setMergedLogo(e.target.value)}
              />
              <div
                className={cn('all-brands-results-logo', !cdnLogo && 'all-brands-results-logo--missing')}
                onClick={() => {
                  if (cdnLogo) window.open(cdnLogo, '_blank');
                }}
              >
                {cdnLogo && <img src={cdnLogo} />}
              </div>
            </label>
          );
        })}
      </div>
      <div className='all-brands-merge-actions'>
        <button className='all-brands-merge-actions-save' disabled={isSaving} onClick={() => onSave({ name: mergedName, logo: mergedLogo })}>
          {isSaving ? <Loader /> : 'Save'}
        </button>
        <button className='all-brands-merge-actions-cancel' disabled={isSaving} onClick={() => onCancel()}>
          {isSaving ? <Loader /> : 'Cancel'}
        </button>
      </div>
    </div>
  );
};

AllBrandsMergeModal.propTypes = {
  brands: PropTypes.array.isRequired,
  isSaving: PropTypes.bool.isRequired,
  isConflicting: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
};

export default AllBrandsMergeModal;
